const userManagementEn = {
    wareHouse: require('../../lang/en/user_management/BusinessAreaWareHouse').default,
    city: require('../../lang/en/user_management/City').default,
    company: require('../../lang/en/user_management/Company').default,
    businessArea: require('../../lang/en/user_management/CompanyBusinessArea').default,
    costCenter: require('../../lang/en/user_management/CostCenter').default,
    country: require('../../lang/en/user_management/Country').default,
    currency: require('../../lang/en/user_management/Currency').default,
    mainMenu: require('../../lang/en/user_management/MainMenu').default,
    permissionMenu: require('../../lang/en/user_management/PermissionMenu').default,
    role: require('../../lang/en/user_management/Role').default,
    rolePermission: require('../../lang/en/user_management/RolePermission').default,
    state: require('../../lang/en/user_management/State').default,
    subMenu: require('../../lang/en/user_management/SubMenu').default,
    tax: require('../../lang/en/user_management/Tax').default,
    taxType: require('../../lang/en/user_management/TaxType').default,
    userRole: require('../../lang/en/user_management/UserRole').default,
};

export default userManagementEn;